import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import TablePagination from '@mui/material/TablePagination'
import { StyledTableCell, StyledTableRow } from './Style'
import { IUser } from '../../interfaces/IUser'
import { useNavigate } from 'react-router-dom'
import * as TXT from './../../util/Texts'
import Swal from 'sweetalert2'
import { ERROR_ALERT, SUCCESS_ALERT } from './../../util/AlertsMsg'
import * as UserService from './../../services/User.service'
import * as SG from './../../style/Styles'

interface Props {
    data: IUser[]
    page: number
    total: number
    limit: number
    onPageChange: (newPage: number) => void
}

export default function UserTable({data, page, total, limit, onPageChange}:Props) {

    const navigate = useNavigate()

    const removeUser = (id:number|string|undefined, index:any) => {

        Swal.fire({
            title: TXT.ATTENTION,
            text: TXT.CONFIRM_REMOVE_USER,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'CANCELAR',
            confirmButtonText: 'SIM'
        }).then( async (result) => {

            if (result.isConfirmed) {
                
                const result = await UserService.RemoveUser(id)
                
                if (result.data && result.data.status) {

                    data.splice(index, 1);

                    SUCCESS_ALERT(TXT.REMOVED)
                    
                    setTimeout(()=>{
                        window.location.reload()
                    },1500)
                } else {
                    ERROR_ALERT(TXT.WRONG_TRY_AGAIN)
                }
                
            }

        })

    }

    return (
        <TableContainer component={Paper}>
            <Table aria-label="customized table">
            <TableHead>
                <TableRow>
                    <StyledTableCell className='userTh upperCase'>{TXT.NAME}</StyledTableCell>
                    <StyledTableCell className='userTh upperCase'>{TXT.REGISTER}</StyledTableCell>
                    <StyledTableCell className='userTh upperCase'>{TXT.PLANT}</StyledTableCell>
                    <StyledTableCell className='userTh upperCase'>{TXT.DEPARTMENT}</StyledTableCell>
                    <StyledTableCell className='userTh upperCase'>{TXT.COUNTRY}</StyledTableCell>
                    <StyledTableCell className='userActionTh userTh'></StyledTableCell>
                </TableRow>
            </TableHead>
            <TableBody>
            {data.length > 0 && data.map((row, i) => (
                <StyledTableRow key={row.id}>
                    <StyledTableCell className='txtTd'>{row.name}</StyledTableCell>
                    <StyledTableCell className='txtTd'>{row.register}</StyledTableCell>
                    <StyledTableCell className='txtTd'>{row.cs}</StyledTableCell>
                    <StyledTableCell className='txtTd'>{row.department}</StyledTableCell>
                    <StyledTableCell className='txtTd'>{row.country ? row.country.name : '-'}</StyledTableCell>
                    <StyledTableCell align="center">

                        <SG.Span title={`${TXT.EDIT_USER}`} onClick={()=>{ navigate(`/users-form/${row.id}`) }} className='alignMidd'>
                            <SG.I className="fa-solid fa-pen-to-square"></SG.I>
                        </SG.Span>
                        <SG.Span title={`${TXT.REMOVE_USER}`} onClick={()=>{ removeUser(row.id, i) }} className='alignMidd'> 
                            <SG.I className="fa-solid fa-trash-can"></SG.I>
                        </SG.Span>
                    
                    </StyledTableCell>
                </StyledTableRow>
            ))}
            </TableBody>
            </Table>
            <TablePagination
                component="div"
                count={total}
                page={page - 1}
                onPageChange={(e, newPage) => onPageChange(newPage + 1)}
                rowsPerPage={limit}
                rowsPerPageOptions={[limit]}
                labelRowsPerPage={TXT.REGISTERS_PER_PAGE}
                labelDisplayedRows={({ from, to, count }) => `${from}-${to} ${TXT.OF} ${count}`}
            />
        </TableContainer>
    )
}
  